<template>
    <v-card class="elevation-0">
        <v-card-title>
            <!-- {{drugName}}-->
            Prescription Details
        </v-card-title>
        <v-card-text>
            <v-alert type="warning" v-if="warning">
                {{ warning }}
            </v-alert>
            <v-form ref="form1" :disabled="drugName == null">
                <v-progress-linear indeterminate v-if="isLoading"></v-progress-linear>
                <v-select :disabled="drugName == null || isLoading || component_data == null" label="Type" v-model="DrugSubType" :items="component_types" item-text="label" return-object :rules="[form_rules.required]"></v-select>
                <v-select :disabled="drugName == null || isLoading || DrugSubType == null " label="Form" v-model="DrugForm" :items="component_forms" item-text="label" return-object :rules="[form_rules.required]"></v-select>
                <v-select :disabled=" drugName == null || isLoading || DrugForm==null " label=" Dosage" v-model="DrugStrength" :items="component_dosages" item-text="label" return-object></v-select>
                <v-select :disabled="drugName == null || isLoading || DrugStrength == null" label="Quantity" v-model="DrugQuant" :items="component_quantities" item-text="label" item-value="value" return-object></v-select>
                <v-text-field outlined v-model="formZipCode" label="ZipCode" persistent-hint>
                </v-text-field>
                <v-btn color="#46c3b2" depressed dark @click="pharmacyLookup">Find lowest price</v-btn>
            </v-form>
        </v-card-text>
        <v-overlay :value="pharmaciesLoading" class="text-center">
            Searching Pharmacies in Your Area...
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-card>
</template>
<script>
import GlicAPI from './GlicAPI.js'  
import { debounce } from 'vue-debounce'
export default {
    props: ['value', 'drugName', 'zipcode'],
    data: function() {
        return {
            isLoading: false,
            pharmaciesLoading: false,
            component_data: null,
            DrugSubType: null,
            DrugForm: null,
            DrugStrength: null,
            DrugQuant: null,
            formZipCode: null,
            components: {
                DrugName: null,
                ZipCode: null,
                Quant: null,
                MultiSource: null,
                Dosage: null,
                Type: null
            },
            pharmacies: [],
            warning: null,
            is_valid: false
        }
    },
    mounted: function() {
        var g = this;
        g.resetComponents();
        this.formZipCode = this.zipcode
    },
    computed: {
        'component_types': function() {
            if (this.component_data == null || typeof this.component_data.brand == 'undefined' || typeof this.component_data.generic == 'undefined') {
                return []
            }
            var r = [];
            this.component_data.generic.forEach(function(item) {
                item.label = item.sub_drug_name + " (Generic)"
                item.MultiSource = "Generic"
                r.push(item)
            })
            this.component_data.brand.forEach(function(item) {
                item.label = item.sub_drug_name + " (Brand Drug)"
                item.MultiSource = "Brand"
                r.push(item)
            })
            return r;
        },
        'component_forms': function() {
            var g = this
            if (this.DrugSubType == null) {
                return []
            }
            var r = [];
            this.DrugSubType.types.forEach(function(item) {
                item.label = g.translateForm(item.dose); // translate this
                r.push(item)
            })
            return r;
        },
        'component_dosages': function() {
            if (this.DrugForm == null) {
                return []
            }
            var r = [];
            //sort dosages
            this.DrugForm.strength.sort((a, b) => (parseFloat(a.Strength) > parseFloat(b.Strength)) ? 1 : -1)
            this.DrugForm.strength.forEach(function(item) {
                item.label = item.Strength; // translate this
                r.push(item)
            })
            return r;
        },
        'component_quantities': function() {
            if (this.DrugStrength == null) {
                return []
            }
            var r = [];
            this.DrugStrength.Quantity.forEach(function(item) {
                r.push({label: item.DisplayQuantity, value: {NDC: item.NDCCode, Quant: item.Quantity}})
            })
            return r;
        },
        form_rules() {
            return {
                'required': v => !!v || 'Required!',
                'date': function(v) {
                    if (typeof v == 'undefined' || v == null || v == '') {
                        return true
                    }
                    if (moment(v, 'YYYY-MM-DD', true).isValid()) {
                        return true;
                    }
                    return 'Enter a valid date';
                },
                'int': function(v) {
                    if (typeof v == 'undefined' || v == null || v == '') {
                        return true
                    }
                    var n = Number(v)
                    if (Number.isInteger(n)) {
                        return true;
                    }
                    return 'Enter a whole number';
                },
                'email': v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
                'zip': v => /^[0-9]{5}(?:-[0-9]{4})?$/.test(v) || 'Enter a valid zipcode', // explnation of this regex can be found here https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s14.html
                'phone': function(v) {
                    if (typeof v == 'string') {
                        v = v.replaceAll("-", "")
                        if (v != null && (Number.isInteger(Number(v)) && v.length >= 10)) {
                            return true
                        }
                    }
                    return 'Please enter a valid phone number in the phone field.'
                },
            }
        },
    },
    methods: {
        //emit's an update event so that the parent component can grab the name. 
        updateValue: function(v) {
            this.$emit('input', v);
        },
        updateResults: function(v) {
            this.$emit('results', v);
        },
        validateForm: function() {
            this.is_valid = this.$refs['form1'].validate()
        },
        getDrugComponents: function(v) {
            var g = this
            this.isLoading = true;
            this.resetComponents();
            GlicAPI.drugcomponents(v).then(function(json) {
                g.$set(g, 'component_data', json[0].data[0])
                g.$nextTick(g.setDefaults)
                g.isLoading = false
            }).catch(function() {
                g.isLoading = false
            });
        },
        pharmacyLookup: function() {
            var g = this
            this.warning = null
            if (!this.$refs['form1'].validate()) {
                this.warning = "Please correct invalid fields."
                setTimeout(function() { g.warning = null }, 6000)
                this.pharmaciesLoading = false;
                return false;
            }
            this.pharmaciesLoading = true;
            setTimeout(function() {
                g.components = {
                    'ZipCode': g.formZipCode,
                    'NDC': g.DrugQuant.value,
                    'Quant': g.DrugQuant.label,
                };
                GlicAPI.pharmacy(g.components).then(function(json) {
                    g.updateResults(json[0].data)
                    g.pharmaciesLoading = false
                }).catch(function() {
                    g.pharmaciesLoading = false
                });
            }, 250)
        },
        resetComponents: function() {
            this.components = {
                DrugName: null,
                ZipCode: null,
                Quant: null,
                MultiSource: null,
                Dosage: null,
                Type: null
            }
            this.DrugSubType = null
            this.DrugForm = null
            this.DrugStrength = null
        },
        setDefaults: function() {
            var g = this;
            this.DrugSubType = this.component_types[0];
            this.$nextTick(function() {
                g.DrugForm = g.component_forms[0];
                g.$nextTick(function() {
                    g.DrugStrength = g.component_dosages[0];
                    g.$nextTick(function() {
                        g.DrugQuant = g.component_quantities[0];
                    })
                })
            })
        },
    },
    watch: {
        'value': function(v) {
            this.dont_search = true
            this.updateValue(v, false);
        },
        'zipcode': function(newV) {
            this.components.ZipCode = newV
            this.formZipCode = newV
        },
        'formZipCode': function(newV) {
            this.$emit('update:zipcode', newV)
        },
        'drugName': function(newV) {
            this.getDrugComponents(newV);
        },
        'DrugSubType': function(newV) {
            if (newV == null) {
                this.components.DrugName = null
                return
            }
            this.components.DrugName = newV.sub_drug_name
        },
        'DrugForm': function(newV) {
            if (newV == null) {
                this.components.Type = null
                return
            }
            this.components.Type = newV.dose
        },
        'DrugStrength': function(newV) {
            if (newV == null) {
                this.components.dosage = null
                return
            }
            this.components.dosage = newV.Strength
        },
        'DrugQuant': function() {
            //this.$nextTick(validateForm)
        }
    }
}
</script>